var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 80,
    width: 110,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse",
    id: "mask0_118_481"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    fill: "#D9D9D9",
    height: 80,
    width: 110
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_2",
    mask: "url(#mask0_118_481)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0BB3F0",
    id: "svg_3",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "m27.02326,18.5575c7.93577,-2.0924 15.83542,-3.9318 23.82786,-4.2478c9.00166,-0.3558 18.14612,-0.668 27.10892,1.424c4.43516,1.0352 8.85525,2.7538 13.21991,4.8029c3.81878,1.7926 7.82253,3.8073 11.29817,8.0128c1.33579,1.6164 2.8686,3.8426 3.23855,7.4577c0.61578,6.0178 -1.4822,11.7171 -3.47233,14.9155c-2.96561,4.7662 -6.75607,7.101 -10.21484,9.0989c-6.18608,3.5734 -12.52279,5.9618 -18.8583,7.6267c-8.39583,2.2063 -16.86908,3.2349 -25.31461,3.7651c-10.59623,0.6652 -21.92597,1.7461 -32.38622,-3.1858c-3.27142,-1.5425 -13.29104,-6.4249 -11.18126,-19.7908c1.74129,-11.0314 8.96814,-15.6588 12.72094,-18.2944c8.27975,-5.8148 18.15564,-8.8031 26.65239,-11.44c18.35037,-5.695 36.7369,-8.2531 55.22645,-9.7023"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.c9a2d6282cc2dd62b582ff249654223c.svg";
export { ForwardRef as ReactComponent };